"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidIntendedCredit = exports.isProductType = exports.getProductLabel = void 0;

var _constants = require("../constants");

var _mocks = require("../mocks");

const labelsForProduct = {
  [_constants.ProductTypes.AUTO]: 'auto',
  [_constants.ProductTypes.HOME]: 'home'
};

const getProductLabel = productType => labelsForProduct[productType];

exports.getProductLabel = getProductLabel;

const isProductType = product => Object.values(_constants.ProductTypes).includes(product);

exports.isProductType = isProductType;

const isValidIntendedCredit = (intendedCredit, product) => {
  var _CreditRangeByProduct, _CreditRangeByProduct2;

  return intendedCredit >= ((_CreditRangeByProduct = _mocks.CreditRangeByProduct[product]) == null ? void 0 : _CreditRangeByProduct.min) && intendedCredit <= ((_CreditRangeByProduct2 = _mocks.CreditRangeByProduct[product]) == null ? void 0 : _CreditRangeByProduct2.max);
};

exports.isValidIntendedCredit = isValidIntendedCredit;